/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import * as ActionTypes from './actionTypes'

export const DefaultState = {
  config: {},
  mutableConfig: {
    severityOptions: [],
  },
  responseError: {},
  isFetching: false,
  isSaving: false,
  isValidating: false,
}

const reducer = (state = DefaultState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_CLOSERULE_CONFIG:
      return {
        ...state,
        isFetching: true,
        responseError: {},
      }
    case ActionTypes.FETCH_CLOSERULE_CONFIG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        config: { ...action.config },
        mutableConfig: { ...action.config },
      }
    case ActionTypes.FETCH_CLOSERULE_CONFIG_FAILURE:
      return {
        ...state,
        isFetching: false,
        responseError: action.responseError,
        config: {},
        mutableConfig: { severityOptions: [] },
      }
    case ActionTypes.SAVE_CLOSERULE_CONFIG:
      return {
        ...state,
        isSaving: true,
        responseError: {},
      }
    case ActionTypes.SAVE_CLOSERULE_CONFIG_SUCCESS:
      return {
        ...state,
        isSaving: false,
        config: { ...action.config },
        mutableConfig: { ...action.config },
      }
    case ActionTypes.SAVE_CLOSERULE_CONFIG_FAILURE:
      return {
        ...state,
        isSaving: false,
        responseError: action.responseError,
      }
    default:
      return state
  }
}

export default reducer
